const createBuildTypes = {
  CREATE_BUILD: "CREATE_BUILD",
  CREATE_BUILD_COMMIT: "CREATE_BUILD_COMMIT",
  CREATE_BUILD_ROLLBACK: "CREATE_BUILD_ROLLBACK",

  RESET_BUILD: "RESET_BUILD",
};

export default createBuildTypes;